<template>
  <div>
    <div class="pwd-title">
      <van-nav-bar title="账号设置" left-arrow @click-left="goBlack"></van-nav-bar>
    </div>
    <div class="pwd-content">
      <div class="pwd-c-title">密码修改</div>
      <div class="pwd-c-ipt">
        <van-field v-model="oldpwd" :type="pwdType" placeholder="请输入旧密码" />
        <van-field v-model="newpwd" :type="pwdType" placeholder="请输入新密码" />
        <van-field v-model="newpwd2" :type="pwdType" placeholder="请再次输入新密码" />
      </div>
    </div>
    <div class="pwd-btn">
      <van-button type="primary" @click="changepwd()">确定</van-button>
    </div>
  </div>
</template>

<script>
import { changPassword } from "@/api/login.js";
export default {
  data() {
    return {
      userId: JSON.parse(localStorage.getItem("user")).userId,
      oldpwd: "",
      newpwd: "",
      newpwd2: "",
      pwdType: "password",
    };
  },

  created() {},
  methods: {
    changepwd() {
      if (this.oldpwd === "") {
        this.$toast("旧密码不能为空");
        return false;
      }
      if (this.newpwd === "") {
        this.$toast("新密码不能为空");
        return false;
      }
      if (this.newpwd2 === "") {
        this.$toast("新密码不能为空");
        return false;
      }
      if (this.newpwd !== this.newpwd2) {
        this.$toast("新密码不一致，请检查");
        return false;
      }
      if (this.newpwd.length < 6) {
        this.$toast("新密码长度不得小于6位");
        return false;
      }
      if (this.oldpwd === this.newpwd) {
        this.$toast("旧密码与新密码一致，请确认");
        return false;
      }
      const data = {
        userId: this.userId,
        password: this.oldpwd,
        newPassword: this.newpwd,
      };
      changPassword(data).then((res) => {
        var _this = this;
        if (res.code == 0) {
          this.$toast("密码修改成功");
          setTimeout(function () {
            localStorage.removeItem("Token");
            localStorage.removeItem("user");
            localStorage.removeItem("firstload");
            _this.$router.push("/login");
          }, 1000);
        }
      });
    },
    goBlack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.pwd-title {
  height: 12vw;
  .van-nav-bar {
    background-color: rgb(37, 201, 145) !important;
  }
}
.pwd-content {
  margin-top: 21.389vw;
  padding: 0 9.259vw;
  .pwd-c-title {
    font-size: 6.667vw;
    color: #24292e;
    font-weight: 500;
    margin-bottom: 13.519vw;
  }
}
.pwd-c-ipt {
  .van-cell {
    // background-color: red;
    border-bottom: 1px solid rgb(211, 216, 220);

    padding: 5vw 0;
    .van-field__control {
      font-size: 13vw;
    }
  }
}
.pwd-btn {
  margin-top: 23.796vw;
  padding: 0 9.259vw;
  height: 10vw;
  border: none;
  button {
    width: 100%;
    border-radius: 3vw;

    font-size: 5vw;
    border: none;
    background-color: rgb(37, 201, 145);
  }
}
</style>
<style lang="less">
.pwd-c-ipt {
  .van-field__control {
    font-size: 5vw;
  }
}
</style>


